import { Flex, Group, Space, Title, UnstyledButton, Text, ActionIcon, TabsValue, Input, ScrollArea, Avatar, Radio, Stack, Tooltip } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { shallowEqual } from 'react-redux';
import { Link, useNavigate, Outlet, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { deleteCurrent, getInfosIndustry, setIsAuthorizeAction, updateCompanyName, updateCompanyNameMessage, updateCurrent, updateCurrentUserOrganizationInfo, updateInfosIndustry } from 'src/store';

import classNames from 'classnames';
import styles from './styles.module.scss';
import {  Button, Checkbox, Divider, Modal, Popover, Select, TextInput } from '@common/components';
import { getAccountOptions } from 'src/constants/accountOptions';
import { Auth } from 'aws-amplify';
import * as yup from 'yup';
import { validationPattern } from '@common/helpers';
import { useForm, yupResolver } from '@mantine/form';
import { useDisclosure, useDocumentTitle, useMediaQuery } from '@mantine/hooks';
import { useAlert, useFormFocus } from '@common/hooks';

import { removetOnboardingStatus } from '../../helpers/localStorageHelper';
import { PATHS } from '../../constants';
import { ArrowUpRight, Briefcase, Edit2, Trash2, UserPlus, Image, Mail, MoreVertical, Octagon, Plus, Settings, Tag, User, Users, Lock } from '@geist-ui/icons';
import { ICustomOptionProps } from '@common/types/types';
import i18n from '@common/i18n/config';
import { Tabs, rem } from '@mantine/core';
import MyOrganisations from '../MyOrganisations';
import { industryOptions } from 'src/constants/industryOptions';
import { apiInstance } from 'src/services';
import { AddSiteForm } from 'src/components';

 
const AccountPage = (): JSX.Element => {
  const accountRef = useRef<HTMLDivElement>(null);
  const passwordRef =useRef<HTMLDivElement>(null);
  const notificationsRef =useRef<HTMLDivElement>(null);
  const organizationRef =useRef<HTMLDivElement>(null);
  const usersRef =useRef<HTMLDivElement>(null);
  const clientsRef =useRef<HTMLDivElement>(null);
  const hiddenRef = useRef<HTMLDivElement>(null); // Hidden element for initial focus reset

  const navigate = useNavigate();
  const { pageTab, siteUUID, option } = useParams();

  const { showAlert } = useAlert();
  const [opened, { open, close }] = useDisclosure(false);
  const options = getAccountOptions();
  const dispatch = useAppDispatch();
  const { data } = useAppSelector((state) => state.user, shallowEqual);
  const [t] = useTranslation('account');
  const [c] = useTranslation('common');
  useDocumentTitle(t('title'));
  const { organizationId } = useParams();
  const user = useAppSelector((state) => state.user.data, shallowEqual);
  const [activeTab, setActiveTab] = useState<TabsValue>(pageTab || 'Account Details');
  // set role 
  const [ userRole , setUserRole ]  = useState('admin')
  const { updateCompanyNameError, updateNameCompany, getInfoIndustry, loadingUpdateCompanyName } = useAppSelector((state) => state.organization, shallowEqual);

  const navigateToWebsiteListHandler = (): void =>
    navigate({
      pathname: PATHS.DASHBOARD,
      search: '?focusTitle=true',
    });
  const [initialValues, setInitialValues] = useState<Record<string, string|undefined >>({
        companyname:'' ,
        industryField: '',
      })

  // useEffect(() => {
  //   if(!getInfoIndustry?.data[0]?.industry){
  //     return;
  //   }    
  //    setInitialValues((prevValues) => ({
  //     ...prevValues,
  //     industryField: getInfoIndustry.data[0].industry,
  //   }));
   
    
  // }, [getInfoIndustry])

  useEffect(() => {
    // Set new values into the form
    form.setValues(initialValues);
  }, [initialValues]); 

  const [companyname, setcompanyname] = useState('');

  // useEffect(() => {
  //   if(companyname){
  //     setInitialValues((prevValues) => ({
  //       ...prevValues,
  //       companyname: companyname.trim(),
  //     }));  

  //   }
  // }, [companyname]);
  
  const validationFormSchema = yup.object().shape({
    companyname: validationPattern.companyName,
    industryField: validationPattern.industryField,
  });

  const form = useForm({
    initialValues: initialValues,
    validate: (values) => {
    
    const verify  =  yupResolver(validationFormSchema)
    const result = verify(values)
      // console.log( result  );
      if ( Object.keys(result).length > 0  ) {
        setNeedFocus(true)
      }else {
        setNeedFocus(false)
      }
      return result
    } 
  });
  const { setNeedFocus } = useFormFocus({ formErrors: form.errors });



  const successMessage = (): void => {
    showAlert({
      id: 'GeneralInfo',
      title: c('Success'),
      message: `${t('generalInfoSuccess')}`,
      variant: 'success',
    });
  };

  const deleteCurrentSuccessMessage = (): void => {
    showAlert({
      id: 'CurrentUserDelete', 
      title: c('Success'),
      message: `${t('currentUserDeleteSuccess')}`,
      variant: 'success',
    });
  };

  const onSubmitHandler = async (values: Record<string, string|undefined>): Promise<void> => {
   
    if(!values.companyname ||  !values.industryField){
      return;
    }    
    setcompanyname(values.companyname);
    const _compnyName = values.companyname.trim(); 
    dispatch(updateCompanyName({ newName: _compnyName, company_id:company_id  }));
    dispatch(updateInfosIndustry({ industry: values.industryField }));
    const updatedData = {
      ...data,
      company_name: _compnyName
    };
    dispatch(updateCurrentUserOrganizationInfo({data:updatedData}));
  };

  useEffect(() => {
    if (data.firstName && data.lastName && !form.values.firstName && !form.values.lastName) {
      form.setValues({ firstName: data.firstName, lastName: data.lastName });
    }
  }, [data]);

  const changeAvailableAccount = (field: string, value: boolean): void => {
    dispatch(updateCurrent({ data: { [field]: value } }));
  };
  const deleteCurrentUser = async (): Promise<void> => {
    dispatch(deleteCurrent({ successMessage: deleteCurrentSuccessMessage }));
    await Auth.signOut();
    dispatch(setIsAuthorizeAction(false));
    removetOnboardingStatus();
    navigate(PATHS.LOGIN);
  };

  // roles list
  const  rolesList = [ 
    {
      label: 'Admin',
      value: 'admin',
    },
    {
      label: 'User',
      value: 'user',
    },
    {
      label: 'Viewer',
      value: 'viewer',
    },
  ]
  const isMobile = useMediaQuery('(max-width: 768px)');


  const handleTabChange = (value: TabsValue): void => {
    if (document.title != value) {
      document.title = String( value?.toString());
    }
    navigate(`/account/${value}`)
    
    // if(organizationId){
    //   navigate(`/account/Account Details`);
    // }
    setActiveTab(value);
    form.reset();
  };

  const handleFocus = (tab : string | TabsValue) => {
    if (tab === 'Account Details' && accountRef.current) {
      accountRef.current.focus();
    } else if (tab === 'Password' && passwordRef.current) {
      passwordRef.current.focus();
    } else if (tab === 'Notifications' && notificationsRef.current) {
      notificationsRef.current.focus();
    }else if (tab === 'Organisations' && organizationRef.current) {
      organizationRef.current.focus();
    }else if (tab === 'Users' && usersRef.current) {
      usersRef.current.focus();
    }else if (tab === 'Clients' && clientsRef.current) {
      clientsRef.current.focus();
    }
  };
  useEffect(() => {
    if (pageTab === ":pageTab") {
      navigate(`/account/Account Details`);
    } else {
      setActiveTab(pageTab || 'Account Details');
    }
    handleFocus(pageTab ?? 'Account Details');
  }, [pageTab, navigate]);

  useEffect(() => {
    // Set focus to the hidden element first
    if (hiddenRef.current) {
      hiddenRef.current.focus();
    }
    // After a short delay, set focus to the active tab content
    setTimeout(() => {
      window.addEventListener('keydown' , handleKeyForHeadingLevelOne)
      handleFocus(activeTab);
      return () => {
        window.removeEventListener('keydown' , handleKeyForHeadingLevelOne)
      }
    }, 100);
  }, [activeTab]);


  function handleKeyForHeadingLevelOne(event: any) {    
    if (event.keyCode === 72  || event.keyCode === 39 ) {
      let ref: React.RefObject<HTMLDivElement> | null = null;
  
      switch (activeTab) {
        case 'Account Details':
          ref = accountRef;
          break;
        case 'Password':
          ref = passwordRef;
          break;
        case 'Notifications':
          ref = notificationsRef;
          break;
        case 'Organisations':
          ref = organizationRef;
          break;
        case 'Users':
          ref = usersRef;
          break;
        case 'Clients':
          ref = clientsRef;
          break;
        default:
          break;
      }
  
      if (ref && ref.current) {
        const h2Element = ref.current.querySelector('h1');
        if (h2Element) {
          h2Element.focus();
          // h2Element.style.border = '1px solid #5b5eff'
        }
      }
    }
  }
  const dummyUsers = [
    { name: 'John Doe', email: 'john.doe@example.com', avatarInitials: 'JD' , role : 'Owner' },
    { name: 'Jane Smith', email: 'jane.smith@example.com', avatarInitials: 'JS' , role : 'Viewer'  },
    { name: 'Michael Johnson', email: 'michael.johnson@example.com', avatarInitials: 'MJ' ,role : 'Viewer' },
    { name: 'Emily Davis', email: 'emily.davis@example.com', avatarInitials: 'ED' ,role : 'Viewer' },
    { name: 'Chris Lee', email: 'chris.lee@example.com', avatarInitials: 'CL' ,role : 'Viewer' },
    { name: 'Anna White', email: 'anna.white@example.com', avatarInitials: 'AW' , role : 'Editer'  },
    { name: 'David Clark', email: 'david.clark@example.com', avatarInitials: 'DC',role : 'Viewer' },
    { name: 'Sophia Hall', email: 'sophia.hall@example.com', avatarInitials: 'SH' ,role : 'Editer' },
    { name: 'James Lewis', email: 'james.lewis@example.com', avatarInitials: 'JL' , role : 'Editer'},
    { name: 'Olivia Martinez', email: 'olivia.martinez@example.com', avatarInitials: 'OM', role : 'Editer'}
  ]  
  const { company_id } = useAppSelector((state) => state.user.data, shallowEqual);
  useEffect(() => {
    
    if (!updateNameCompany) {
      return;
    }
    showAlert({
      id: 'updateNameCompany',
      title: c('Success'),
      message: `company details updated sucessfully`,
      variant: 'success',
    });
    dispatch( updateCompanyNameMessage() ) 

  }, [updateNameCompany])

  useEffect(() => {

    dispatch(getInfosIndustry());    

  }, [])
  const [addSite, setAddSite] = useState(false);
  const { loading , error } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const { isLoading } = useAppSelector((state) => state.payment);
  const { websites } = useAppSelector((state) => state.payment.data.metadata);
  const siteLists  = useAppSelector((state) => state.siteList.data, shallowEqual);
  const loadingSiteList = useAppSelector((state) => state.siteList.loading);

  // const canDisplayButton = !(siteLists.length >= Number(websites)) && !isLoading && !loadingSiteList;
  const [j] = useTranslation('common');
  const changeFormState = (): void =>{
    setAddSite(!addSite);
  } 
  const navigateToPayment = (): void => {
    // if(!hasPermission){
    //       return;
    //   }
    apiInstance.get('payment/portal').then((res) => {
      window.location = res.data.url;
    });
  };
  return (
    <main className={styles.tabContainer}  >
      <div ref={hiddenRef} tabIndex={-1} style={{ position: 'absolute', left: '-9999px' }} />
          <Flex justify={"end"} align={"end"} direction={"column"}>
      </Flex>
        <div ref={hiddenRef} tabIndex={-1} style={{ position: 'absolute', left: '-9999px' }} />
          <div className={styles['right-content']}>
            {/* <Title className={styles['second-heading']} color={'#264547'} mb={'18px'} order={1}>
              {t('nav.accountDetails')}
            </Title> */}
              {/* <p>{t('nav.accountDesrption')}</p> */}
              <Space h={'md'} />
              <MyOrganisations page = "account-details" panel = {option} siteUUID = {siteUUID} />
              {/* <Link to={"javascript:;"} className={styles.deleteAccount} onClick={open}> {t('deleteAccountAction')} </Link> */}
            </div>


    </main>    
  );
};

export default AccountPage;
